import { memo } from 'react';

function BulletIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" fill="none" viewBox="0 0 4 4">
      <circle cx="2" cy="2" r="2" fill="#637381" transform="matrix(1 0 0 -1 0 4)" />
    </svg>
  );
}

export default memo(BulletIcon);
